export enum RmEtd { 
    ETD =12,
 }